export default "__VITE_ASSET__CgavZeVk__"